module.exports = __webpack_public_path__ + "assets/img/f-b-1.1e17a6f5.png";